import { Absent_getInstance2zpu0zcae0yg1 as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePartyInputClass;
function SavePartyInput() {
  if (SavePartyInputClass === VOID) {
    class $ {
      constructor(partyId, name, email, pairingRule, badgesEnabled, defaultBadgeName, alternateBadgeName, callSignsEnabled, animationsEnabled, animationSpeed) {
        name = name === VOID ? Absent_getInstance() : name;
        email = email === VOID ? Absent_getInstance() : email;
        pairingRule = pairingRule === VOID ? Absent_getInstance() : pairingRule;
        badgesEnabled = badgesEnabled === VOID ? Absent_getInstance() : badgesEnabled;
        defaultBadgeName = defaultBadgeName === VOID ? Absent_getInstance() : defaultBadgeName;
        alternateBadgeName = alternateBadgeName === VOID ? Absent_getInstance() : alternateBadgeName;
        callSignsEnabled = callSignsEnabled === VOID ? Absent_getInstance() : callSignsEnabled;
        animationsEnabled = animationsEnabled === VOID ? Absent_getInstance() : animationsEnabled;
        animationSpeed = animationSpeed === VOID ? Absent_getInstance() : animationSpeed;
        this.partyId_1 = partyId;
        this.name_1 = name;
        this.email_1 = email;
        this.pairingRule_1 = pairingRule;
        this.badgesEnabled_1 = badgesEnabled;
        this.defaultBadgeName_1 = defaultBadgeName;
        this.alternateBadgeName_1 = alternateBadgeName;
        this.callSignsEnabled_1 = callSignsEnabled;
        this.animationsEnabled_1 = animationsEnabled;
        this.animationSpeed_1 = animationSpeed;
      }
      toString() {
        return 'SavePartyInput(partyId=' + this.partyId_1.toString() + ', name=' + toString(this.name_1) + ', email=' + toString(this.email_1) + ', pairingRule=' + toString(this.pairingRule_1) + ', badgesEnabled=' + toString(this.badgesEnabled_1) + ', defaultBadgeName=' + toString(this.defaultBadgeName_1) + ', alternateBadgeName=' + toString(this.alternateBadgeName_1) + ', callSignsEnabled=' + toString(this.callSignsEnabled_1) + ', animationsEnabled=' + toString(this.animationsEnabled_1) + ', animationSpeed=' + toString(this.animationSpeed_1) + ')';
      }
      hashCode() {
        var result = this.partyId_1.hashCode();
        result = imul(result, 31) + hashCode(this.name_1) | 0;
        result = imul(result, 31) + hashCode(this.email_1) | 0;
        result = imul(result, 31) + hashCode(this.pairingRule_1) | 0;
        result = imul(result, 31) + hashCode(this.badgesEnabled_1) | 0;
        result = imul(result, 31) + hashCode(this.defaultBadgeName_1) | 0;
        result = imul(result, 31) + hashCode(this.alternateBadgeName_1) | 0;
        result = imul(result, 31) + hashCode(this.callSignsEnabled_1) | 0;
        result = imul(result, 31) + hashCode(this.animationsEnabled_1) | 0;
        result = imul(result, 31) + hashCode(this.animationSpeed_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePartyInput()))
          return false;
        if (!this.partyId_1.equals(other.partyId_1))
          return false;
        if (!equals(this.name_1, other.name_1))
          return false;
        if (!equals(this.email_1, other.email_1))
          return false;
        if (!equals(this.pairingRule_1, other.pairingRule_1))
          return false;
        if (!equals(this.badgesEnabled_1, other.badgesEnabled_1))
          return false;
        if (!equals(this.defaultBadgeName_1, other.defaultBadgeName_1))
          return false;
        if (!equals(this.alternateBadgeName_1, other.alternateBadgeName_1))
          return false;
        if (!equals(this.callSignsEnabled_1, other.callSignsEnabled_1))
          return false;
        if (!equals(this.animationsEnabled_1, other.animationsEnabled_1))
          return false;
        if (!equals(this.animationSpeed_1, other.animationSpeed_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePartyInput');
    SavePartyInputClass = $;
  }
  return SavePartyInputClass;
}
//region block: exports
export {
  SavePartyInput as SavePartyInput3ikp23en56cie,
};
//endregion

//# sourceMappingURL=SavePartyInput.mjs.map
